export enum OrderTypeEnum {
  EXTLOG = 'EXTLOG',
  SAP = 'SAP',
  MARKETING = 'MARKETING',
  SERVICE = 'SERVICE'
}
